import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import RefreshIcon from '@material-ui/icons/Refresh';
import useVersionCheck from '../../hooks/useVersionCheck';

const useStyles = makeStyles(() =>
    createStyles({
        banner: {
            backgroundColor: '#1976d2',
            color: '#ffffff',
            fontWeight: 500,
            width: '100%',
            maxWidth: '100%',
        },
        action: {
            color: '#ffffff',
            fontWeight: 600,
            borderColor: '#ffffff',
            marginLeft: 16,
        },
        message: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
        },
    }),
);

const VersionUpdateBanner: React.FC = () => {
    const classes = useStyles();
    const { t } = useTranslation('General');
    const { outdated, latestVersion } = useVersionCheck();

    const handleReload = () => {
        window.location.reload();
    };

    return (
        <Snackbar
            open={outdated}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <SnackbarContent
                className={classes.banner}
                message={
                    <span className={classes.message}>
                        {t('versionOutdatedMessage', { version: latestVersion })}
                    </span>
                }
                action={
                    <Button
                        className={classes.action}
                        variant="outlined"
                        size="small"
                        startIcon={<RefreshIcon />}
                        onClick={handleReload}
                    >
                        {t('versionUpdateButton')}
                    </Button>
                }
            />
        </Snackbar>
    );
};

export default VersionUpdateBanner;
